import { calorieSplit, formatMacro } from '@/lib/format'
import { cn } from '@/lib/cn'
import type { Macros } from '@/lib/macros'

const ENTRIES = [
  { key: 'protein', label: 'P', name: 'Protein', color: 'var(--color-protein)' },
  { key: 'carbs', label: 'C', name: 'Carbs', color: 'var(--color-carbs)' },
  { key: 'fat', label: 'F', name: 'Fat', color: 'var(--color-fat)' },
] as const

/** Compact kcal · P · C · F line, with an optional calorie-split bar. */
export function MacroStrip({
  macros,
  bar = false,
  className,
}: {
  macros: Macros
  bar?: boolean
  className?: string
}) {
  if (macros.kcal === null && macros.protein === null) {
    return <p className={cn('text-xs text-ink-faint', className)}>No nutrition data</p>
  }
  const split = calorieSplit(macros.protein ?? 0, macros.carbs ?? 0, macros.fat ?? 0)
  return (
    <div className={cn('space-y-1.5', className)}>
      <p className="tabular flex flex-wrap items-baseline gap-x-2.5 gap-y-0.5 text-xs text-ink-soft">
        <span>
          <span className="font-semibold text-ink">{formatMacro(macros.kcal)}</span> kcal
        </span>
        {ENTRIES.map((entry) => (
          <span key={entry.key} className="inline-flex items-center gap-1" title={entry.name}>
            <span
              aria-hidden
              className="size-1.5 rounded-full"
              style={{ backgroundColor: entry.color }}
            />
            <span className="sr-only">{entry.name}</span>
            <span aria-hidden className="text-ink-faint">
              {entry.label}
            </span>
            {formatMacro(macros[entry.key])}g
          </span>
        ))}
      </p>
      {bar && split ? (
        <div className="flex h-1 w-full overflow-hidden rounded-full bg-surface-sunken">
          {ENTRIES.map((entry) => (
            <span
              key={entry.key}
              style={{
                width: `${split[`${entry.key}Pct`]}%`,
                backgroundColor: entry.color,
              }}
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}
